import { render } from "./HosterPage.vue?vue&type=template&id=0a81024c&ts=true"
import script from "./HosterPage.vue?vue&type=script&lang=ts"
export * from "./HosterPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__